import { useRef, useEffect, memo } from "react";
import {
  Chart,
  ArcElement,
  Tooltip,
  Legend,
  DoughnutController,
} from "chart.js";


// Register required Chart.js components
Chart.register(ArcElement, Tooltip, Legend, DoughnutController);

const DoughnutChart = ({ labelData, dataSetValue, chartName }) => {
  const chartRef = useRef(null); // Reference for the canvas element
  const chartInstanceRef = useRef(null); // Reference for the Chart instance

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    // Destroy existing chart instance before creating a new one
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    // Create new chart instance
    chartInstanceRef.current = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: labelData,
        datasets: [
          {
            label: "Nos",
            data: dataSetValue,
            backgroundColor: [
              "rgba(255, 99, 132, 0.6)",
              "rgba(54, 162, 235, 0.6)",
              "rgba(255, 206, 86, 0.6)",
              "rgba(75, 192, 192, 0.6)",
              "rgba(153, 102, 255, 0.6)",
              "rgba(255, 159, 64, 0.6)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
          tooltip: {
            enabled: true,
          },
        },
      },
    });

    // Cleanup on unmount
    return () => {
      chartInstanceRef.current?.destroy();
    };
  }, []);
  useEffect(() => {
    if (chartInstanceRef.current) {
      chartInstanceRef.current.data.datasets[0].data = dataSetValue;
      chartInstanceRef.current.update();
    }
  }, [dataSetValue]);
  

  return (
    <>
        <div className="d-flex justify-content-center align-items-center text-start w-100">
            <h4 className="pt-4 pb-3 text-start w-100 px-4">{chartName}</h4>
        </div>
      <div style={{ height: "325px" }}>
        
        <canvas ref={chartRef} width={800} height={400}></canvas>
      </div>
    </>
  );
};

// export default DoughnutChart;
export default memo(DoughnutChart);
